export { default as TableManagement } from "./TableManagement";
